import styled from 'styled-components';

export const Thumb = styled('div')<{ left: number; totalMarks: number }>`
  cursor: grab;
  width: calc(100% / ${({ totalMarks }) => (totalMarks ? totalMarks : 1)});
  height: 50px;
  top: -5px;
  border-radius: ${({ theme }) => theme.x1spacePx * 0.75}px;
  background-color: ${({ theme }) => theme.color.chart01RGBA(0.2)};
`;
